import {
  createOrgAddressRequestSchema,
  orgAddressBulkRequestSchema,
  orgAddressBulkResponseSchema,
  orgAddressListResponseSchema,
  orgAddressSchema,
  updateOrgAddressRequestSchema,
  type CreateOrgAddressRequest,
  type OrgAddressBulkRequest,
  type UpdateOrgAddressRequest,
} from "@chotca/config";
import { z } from "zod";
import type { RequestContext } from "./http";
import { requestJson } from "./http";

// Saved work-locations under an org. Used by the posting form: employer
// picks 1..30 of these per posting. CRUD is gated on org membership
// (OWNER/HR) at the API.
export function createOrgAddressesResource(ctx: RequestContext) {
  return {
    list(orgId: string) {
      return requestJson(ctx, {
        method: "GET",
        path: `/orgs/${orgId}/addresses`,
        dataSchema: orgAddressListResponseSchema,
        auth: true,
      });
    },

    create(orgId: string, body: CreateOrgAddressRequest) {
      const payload = createOrgAddressRequestSchema.parse(body);
      return requestJson(ctx, {
        method: "POST",
        path: `/orgs/${orgId}/addresses`,
        body: payload,
        dataSchema: orgAddressSchema,
        auth: true,
      });
    },

    createBulk(orgId: string, body: OrgAddressBulkRequest) {
      const payload = orgAddressBulkRequestSchema.parse(body);
      return requestJson(ctx, {
        method: "POST",
        path: `/orgs/${orgId}/addresses/bulk`,
        body: payload,
        dataSchema: orgAddressBulkResponseSchema,
        auth: true,
      });
    },

    update(addressId: string, body: UpdateOrgAddressRequest) {
      const payload = updateOrgAddressRequestSchema.parse(body);
      return requestJson(ctx, {
        method: "PATCH",
        path: `/org-addresses/${addressId}`,
        body: payload,
        dataSchema: orgAddressSchema,
        auth: true,
      });
    },

    archive(addressId: string) {
      return requestJson(ctx, {
        method: "POST",
        path: `/org-addresses/${addressId}/archive`,
        dataSchema: z.object({ ok: z.literal(true) }),
        auth: true,
      });
    },
  };
}
